import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import { ModelOfProductGroup } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListProductGroupController, } from '../../controllers/ProductGroups/ListProductGroupsController';

const ProductGroupsList: React.FC = () => {
    const { getProductGroupListController, handleProductGroupListController } = useListProductGroupController();

    if (getProductGroupListController.loading) {
        return <LoadingScreen />
    };

    const actionBodyTemplate = (ProductGroup: ModelOfProductGroup) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleProductGroupListController.openEditDialog(ProductGroup)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleProductGroupListController.openDeleteDialog(ProductGroup)} />
            </React.Fragment>
        );
    };

    const editProductGroupDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleProductGroupListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getProductGroupListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteProductGroupDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleProductGroupListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getProductGroupListController.selectedProductGroup && handleProductGroupListController.removeProductGroup(getProductGroupListController.selectedProductGroup)
                }}
            />
        </React.Fragment>
    );

    const leftProductGroupToolbar = () => {
        return (
            <Link to="/ProductGroupForm">
                <Button label="Cadastrar grupo de produto" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    return (
        <div>
            <Toast ref={getProductGroupListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftProductGroupToolbar}></Toolbar>

                <DataTable className="p-datatable-sm"
                    dataKey="ID" rowHover scrollable scrollHeight={'100%'}
                    value={getProductGroupListController.ProductGroupData}>
                    <Column field="DESCRICAO" header="GRUPO DE PRODUTO"></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid"
                style={{ width: '450px' }}
                visible={getProductGroupListController.editDialog}
                onHide={handleProductGroupListController.closeEditDialog}
                onShow={() => getProductGroupListController.formik.setFieldValue('DESCRICAO', getProductGroupListController.selectedProductGroup?.DESCRICAO)}
                footer={editProductGroupDialogFooter}
                header={`Editar grupo ${getProductGroupListController.selectedProductGroup?.DESCRICAO}`}
                modal
            >
                <div className="p-field">
                    <label htmlFor="description">Nome</label>
                    <InputText id="name" type="text"
                        value={getProductGroupListController.formik.values.DESCRICAO}
                        onChange={getProductGroupListController.formik.handleChange('DESCRICAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getProductGroupListController.formik.touched.DESCRICAO && getProductGroupListController.formik.errors.DESCRICAO,
                        'popup-form-inactive': !(getProductGroupListController.formik.touched.DESCRICAO && getProductGroupListController.formik.errors.DESCRICAO),
                    })}
                    >{getProductGroupListController.formik.errors.DESCRICAO}</div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getProductGroupListController.deleteDialog}
                onHide={handleProductGroupListController.closeDeleteDialog}
                footer={deleteProductGroupDialogFooter}
                header="Remover grupo"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getProductGroupListController.selectedProductGroup && <span>Você tem certeza que deseja deletar o grupo <b>{getProductGroupListController.selectedProductGroup.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default ProductGroupsList;